// domain/capacitacion.rules.js  (reglas puras; testeables con Jest sin mocks)
import { contarAsistentes } from '../../shared/domain/asistentes';
import { nombrePorId, nombresPorIds } from '../../shared/domain/catalogo';

/**
 * Agrega campos derivados (solo para mostrar, buscar y exportar): nombres resueltos desde los
 * catálogos y `asistentes_count` a partir de la lista plana de asistentes.
 */
export const withNombres = (list, { actividades = [], municipios = [], localidades = [], asistentes = [] } = {}) => {
  const counts = contarAsistentes(asistentes, 'id_capacitacion');
  return list.map(item => ({
    ...item,
    actividad_nombre: nombresPorIds(actividades, item.id_actividades).join(', '),
    municipio_nombre: nombrePorId(municipios, item.id_municipio),
    localidad_nombre: nombrePorId(localidades, item.id_localidad),
    asistentes_count: counts.get(item.id) || 0,
  }));
};

/** Ids de municipio distintos presentes en la lista (para pedir solo sus localidades). */
export const municipiosDistintos = list => [...new Set(list.map(item => item.id_municipio).filter(id => id !== null))];

export { sortByRecientes } from '../../shared/domain/coleccion';

export const MSG_SIN_ASISTENTES = 'Agrega al menos un asistente';

/** Regla: una capacitación necesita al menos un asistente. Devuelve null si es válida o el mensaje de error. */
export const validarAsistentes = ids => (Array.isArray(ids) && ids.length > 0 ? null : MSG_SIN_ASISTENTES);
